import { createAction, props } from '@ngrx/store';
import { BatchingApprovalModel } from '@shared/data-access/models';

export const setItemDetail = createAction('[Batch Search Engine] SET ITEM DETAIL', props<{ item: BatchingApprovalModel | null }>());
